import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import Svg from '../../../../component/Svg';
import '../assetes/css/style.css';

export default function DocumentationSidebar() {
    const [openSubmenu, setOpenSubmenu] = useState(null);
    const { pathname } = useLocation();

    // Keep the submenu open if a child item is active
    useEffect(() => {
        if (pathname.startsWith('/admin/ducumentation/surveys/')) {
            setOpenSubmenu('survey');
        } else if (pathname.startsWith('/admin/ducumentation/settings/')) {
            setOpenSubmenu('settings');
        }
    }, [pathname]);

    // Toggle submenus while ensuring only one stays open at a time
    const toggleSubmenu = (menuKey) => {
        setOpenSubmenu((prev) => (prev === menuKey ? null : menuKey));
    };

    return (
        <div className="dashboard-side-menu-wrapper document-sidebar d-flex flex-column align-items-stretch">
            <nav className="dashboard-side-menu position-static">
                <ul className='top-menu'>
                    <div className='back-btn'>
                        <li><NavLink to="/admin/roi">
                            <Svg name="left-arrow" />
                            <span>Back to Calculator</span>  </NavLink>
                        </li>
                    </div>

                    {/* Survey Menu */}
                    <li className="has-subnav">
                        <div
                            className="d-flex drop-wrap align-items-center"
                            onClick={() => toggleSubmenu('survey')}
                        >
                            <div className={`parent-toggle ${openSubmenu === 'survey' ? "active" : ""}`}>
                                <Svg name="survey" />
                                <span className="nav-text">Calculator</span>
                            </div>

                            {/* Toggle Button */}
                            <div className="drop-btn">
                                {openSubmenu === 'survey' ? (
                                    <Svg name="arrow-down" />
                                ) : (
                                    <Svg name="arrow-right" />
                                )}
                            </div>
                        </div>

                        {/* Submenu */}
                        <div className={`collapse ${openSubmenu === 'survey' ? 'show' : ''}`}>
                            <ul className="subnav">
                                <li><NavLink to="/admin/ducumentation/surveys/document-dashboard">Calculator List</NavLink></li>

                                {/* <li><NavLink to="/admin/ducumentation/surveys/document-qandabuilder">Q and A Builder</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-formbuilder">Form Builder</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-reportbuilder">Report Builder</NavLink></li> */}
                                {/* <li><NavLink to="/admin/ducumentation/surveys/document-variables">Variables</NavLink></li> */}
                                {/* <li><NavLink to="/admin/ducumentation/surveys/document-publishshare">Publish and Share</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-questionnarire">Questionnaire</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-thankyoupage">Thank You Page</NavLink></li> */}
                                <li><NavLink to="/admin/ducumentation/surveys/create-calculator">Create Calculator</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-actionsinlist">Actions in Calculator List</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-calculationlogic">Calculation Logic</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/surveys/document-customvariable">Custom Variable</NavLink></li>
                            </ul>
                        </div>
                    </li>

                    {/* Analytics */}
                    {/* <li>
                        <div className='drop-wrap'>
                            <NavLink to="/admin/ducumentation/document-analytics">
                                <Svg name="analytics" />
                                <span className="nav-text">Analytics</span>
                            </NavLink>
                        </div>
                    </li> */}

                    {/* Settings Menu */}
                    <li className="has-subnav">
                        <div
                            className="d-flex drop-wrap align-items-center"
                            onClick={() => toggleSubmenu('settings')}
                        >
                            <div className={`parent-toggle ${openSubmenu === 'settings' ? "active" : ""}`}>
                                <Svg name="settings" />
                                <span className="nav-text">Settings</span>
                            </div>

                            {/* Toggle Button */}
                            <div className="drop-btn">
                                {openSubmenu === 'settings' ? (
                                    <Svg name="arrow-down" />
                                ) : (
                                    <Svg name="arrow-right" />
                                )}
                            </div>
                        </div>

                        {/* Submenu */}
                        <div className={`collapse ${openSubmenu === 'settings' ? 'show' : ''}`}>
                            <ul className="subnav">
                                <li><NavLink to="/admin/ducumentation/settings/document-accountsetting">Account Settings</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/settings/puppeteer-settings">Puppeteer Settings</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/settings/document-users">Users</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/settings/document-roles">Roles</NavLink></li>
                                <li><NavLink to="/admin/ducumentation/settings/document-teams">Teams</NavLink></li>
                            </ul>
                        </div>
                    </li>

                </ul>
            </nav>
        </div>
    );
}
